import showPopup from "../utils/showPopup";

export default function (element, data) {
    const title = data.title;
    const price = data.price;
    const text = data.text;

    element.addEventListener("click", function () {
        const control = showPopup(`
            <h1>${title}</h1>
            <div class="price">${price}</div>
            <div class="text">${text}</div>
            <button type="button" class="button popup-form-button">${window.Application.lang.submitYourApplication}</button>
        `, {
            rootClass: "program-popup",
            onShown: function (popupElement) {
                popupElement.querySelector(".popup-form-button").addEventListener("click", function () {
                    control.close();
                    window.dispatchEvent(new CustomEvent("popupRequestForm", {
                        detail: {
                            program: title
                        }
                    }));
                });
            }
        });
    });
}

// @widgetLoadingMode:lazy-once
// @widgetLoadingChunk:secondary